module.exports = __webpack_public_path__ + "static/puppy-blanket-18b854df7d7bf4d9f0700345219bf93b.jpg";